import { render, staticRenderFns } from "./TransferenciaForm.vue?vue&type=template&id=478e7e81&scoped=true&"
import script from "./TransferenciaForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./TransferenciaForm.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478e7e81",
  null
  
)

export default component.exports